import * as React from 'react';
export var FormFieldBaseContext = /*#__PURE__*/React.createContext({
  labelId: null
});
export var FormFieldBaseProvider = FormFieldBaseContext.Provider;
//# sourceMappingURL=formFieldBaseContext.js.map
